import Vue from 'vue'
import { currency, capitalize } from 'es-sharp'
import { ymd, ymdL, toUpperCase, toLowerCase } from '@/utils/helper'

Vue.filter('currency', currency)
Vue.filter('ymd', ymd)
Vue.filter('ymdL', ymdL)
Vue.filter('upper', toUpperCase)
Vue.filter('lower', toLowerCase)
Vue.filter('cap', capitalize)
